<template>
<v-card :dark="false" flat tile color="rgb(255,255,255)">
    <v-card v-if="pointType === 0" class="pa-5 pb-0" :dark="false" flat tile color="rgb(255,255,255)">
        <v-form v-model="pvalid1" ref="form1">
            <v-layout>
                <div class="ml-3 mt-5" style="font-size: 16px;color: rgb(148,148,148)">{{$vuetify.lang.t('$vuetify.search.rangeSelector.longitude')}}</div>
                <v-text-field
                        :dark="false"
                        grow
                        class="mx-3 ml-6"
                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.longitude')"
                        :value=$store.state.search.longitude
                        v-model=$store.state.search.longitude
                        :rules="[rules.lng]"
                        type="number"
                        append-icon="°"
                ></v-text-field>
            </v-layout>
            <v-layout>
                <div class="ml-3 mt-5" style="font-size: 16px;color: rgb(148,148,148)">{{$vuetify.lang.t('$vuetify.search.rangeSelector.latitude')}}</div>
                <v-text-field
                        :dark="false"
                        class="mx-3 ml-6"
                        :label="$vuetify.lang.t('$vuetify.search.rangeSelector.latitude')"
                        :value=$store.state.search.latitude
                        v-model=$store.state.search.latitude
                        :rules="[rules.lat]"
                        type="number"
                        append-icon="°"
                ></v-text-field>
            </v-layout>
        </v-form>
    </v-card>
    <v-card v-if="pointType === 1" class="pa-5 pb-0" :dark="false" flat tile color="rgb(255,255,255)">
        <v-layout row class="pl-3 pr-3" style="width:100%;">
            <v-form v-model="pvalid2" ref="form2" style="width:100%;">
                <v-layout>
                    <div class="ml-3 mt-5" style="width: 4rem;font-size: 16px;color: rgb(148,148,148)">{{$vuetify.lang.t('$vuetify.search.rangeSelector.longitude')}}</div>
                    <v-text-field
                            class="ml-0"
                            :label="$vuetify.lang.t('$vuetify.search.rangeSelector.d')"
                            :value=lngDegree
                            v-model=lngDegree
                            :rules="[rules.required, rules.lng]"
                            type="number"
                            append-icon="°"
                    ></v-text-field>
                    <v-text-field
                            class="ml-3"
                            :label="$vuetify.lang.t('$vuetify.search.rangeSelector.m')"
                            :value=lngMinute
                            v-model=lngMinute
                            :rules="[rules.required, rules.lt60]"
                            type="number"
                            append-icon="′"
                    ></v-text-field>
                    <v-text-field
                            class="ml-3 mr-3"
                            :label="$vuetify.lang.t('$vuetify.search.rangeSelector.s')"
                            :value=lngSeconds
                            v-model=lngSeconds
                            :rules="[rules.required, rules.lt60]"
                            type="number"
                            append-icon="″"
                    ></v-text-field>
                </v-layout>
                <v-layout>
                    <div class="ml-3 mt-5" style="width: 4rem;font-size: 16px;color: rgb(148,148,148)">{{$vuetify.lang.t('$vuetify.search.rangeSelector.latitude')}}</div>
                    <v-text-field
                            class="ml-0"
                            :label="$vuetify.lang.t('$vuetify.search.rangeSelector.d')"
                            :value=latDegree
                            v-model=latDegree
                            :rules="[rules.required, rules.lat]"
                            type="number"
                            append-icon="°"
                    ></v-text-field>
                    <v-text-field
                            class="ml-3"
                            :label="$vuetify.lang.t('$vuetify.search.rangeSelector.m')"
                            :value=latMinute
                            v-model=latMinute
                            :rules="[rules.required, rules.lt60]"
                            type="number"
                            append-icon="′"
                    ></v-text-field>
                    <v-text-field
                            class="ml-3 mr-3"
                            :label="$vuetify.lang.t('$vuetify.search.rangeSelector.s')"
                            :value=latSeconds
                            v-model=latSeconds
                            :rules="[rules.required, rules.lt60]"
                            type="number"
                            append-icon="″"
                    ></v-text-field>
                </v-layout>
            </v-form>
        </v-layout>
    </v-card>
    <v-row justify="center" align="center">
        <v-btn :color="pointType === 0 ? 'rgba(35, 131, 212, 1)':''" text small @click="pointType = 0">{{$vuetify.lang.t('$vuetify.search.rangeSelector.degree')}}</v-btn>
        <img width="22" height="11" src="../../../assets/Search/dms.png" />
        <v-btn :color="pointType === 1 ? 'rgba(35, 131, 212, 1)':''" text small @click="pointType = 1">{{$vuetify.lang.t('$vuetify.search.rangeSelector.dms')}}</v-btn>
    </v-row>
    <v-row justify="center" align="center" class="ma-2">
        <!-- @click="Search()" -->
        <v-btn
                dark
                depressed
                small
                :disabled="$store.state.search.selectedRangeStore['point'] == ''"
                style="background:linear-gradient(226deg,rgba(50,197,255,1) 0%,rgba(20,66,170,1) 100%); width: 80px;"
        >
            {{$vuetify.lang.t('$vuetify.search.rangeSelector.confirm')}}
        </v-btn>
    </v-row>
</v-card>
</template>

<script>

    export default {
        name: "SearchPointSelector",
        inject:['Search'],
        
        data () {
            return {
                parentContainer: '',
                lngDegree: '0',
                lngMinute: '0',
                lngSeconds: '0',
                latDegree: '0',
                latMinute: '0',
                latSeconds: '0',
                pointType: 0,
                pvalid1: false,
                pvalid2: false,
            }
        },
        computed: {
            rules() {
                return {
                    required: value => !!value || this.$vuetify.lang.t('$vuetify.search.rangeSelector.required'),
                    lng: value => value>=-180 && value<=180 ||  this.$vuetify.lang.t('$vuetify.search.rangeSelector.illegal'),
                    lat: value => value>=-90 && value<=90 ||  this.$vuetify.lang.t('$vuetify.search.rangeSelector.illegal'),
                    gt0: value => value > 0 ||  this.$vuetify.lang.t('$vuetify.search.rangeSelector.gt0'),
                    lt60: value => value>=0 && value<60 || this.$vuetify.lang.t('$vuetify.search.rangeSelector.illegal')
                }
            },
            // pointView() {
            //     return [this.$store.state.search.longitude, this.$store.state.search.latitude]
            // },
            dms() {
                return [this.lngDegree,this.lngMinute,this.lngSeconds,this.latDegree,this.latMinute,this.latSeconds]
            }
        },
        watch: {
            pointType(val) {
                if(val == 1){
                    this.latlngToDms()
                }
            },
            // pointView() {
            //     if (!!this.$store.state.search.longitude && !!this.$store.state.search.latitude){
            //         this.$store.state.search.selectedRangeStore['point'] = {
            //             type: "Point",
            //             coordinates:[this.$store.state.search.longitude, this.$store.state.search.latitude]
            //         }
            //     }
            //     // this.latlngToDms()
            // },
            dms() {
                // if (this.pvalid2){
                    this.$store.state.search.longitude = parseFloat(this.lngDegree) + parseFloat(this.lngMinute/60) + parseFloat(this.lngSeconds/3600)
                    this.$store.state.search.latitude = parseFloat(this.latDegree) + parseFloat(this.latMinute/60) + parseFloat(this.latSeconds/3600)
                // }
            },
        },
        methods: {
            // Search() {
            //     this.parentContainer.searchAll()
            // },
            latlngToDms() {
                if (this.pointType === 1 && this.pvalid1 && this.$store.state.search.latitude !== ''&& this.$store.state.search.longitude !== ''){
                    var value = parseFloat(this.$store.state.search.longitude) + 180
                    this.lngDegree = Math.floor(value)
                    this.lngMinute = Math.floor((value - this.lngDegree) * 60)
                    this.lngSeconds = (value - this.lngDegree) * 3600 % 60
                    this.lngDegree = this.lngDegree - 180

                    value = parseFloat(this.$store.state.search.latitude) + 90
                    this.latDegree = Math.floor(value)
                    this.latMinute = Math.floor((value - this.latDegree) * 60)
                    this.latSeconds = (value - this.latDegree) * 3600 % 60
                    this.latDegree = this.latDegree - 90

                    this.$store.state.search.clickFlag = false
                }
            },
            clearAll(){
                this.$store.state.search.longitude = ''
                this.$store.state.search.latitude = ''
                this.lngDegree = '0'
                this.lngMinute = '0'
                this.lngSeconds = '0'
                this.latDegree = '0'
                this.latMinute = '0'
                this.latSeconds = '0'
                this.$store.state.search.selectedRangeStore.point = ''
            }
        },
        mounted() {
            // this.parentContainer = this.findRealParent(this.$parent)
            this.parentContainer = this.Search
        }
    }
</script>

<style scoped>

</style>
